//@flow
import {makeStyles} from '@material-ui/core';
import React from 'react';
import {useFormContext} from 'react-hook-form';
import CustomTextField from '../../../../../../../elements/CustomTextField/CustomTextField';
import TextAndBackgroundColorSelector from '../../../../../../../elements/TextAndBackgroundColorSelector';
import {MAIN_BANNER_FIELDS} from '../constants';
import {useStoreColorSettings} from '../../../../../../ui/utils';

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
    gap: '1rem',
  },
}));

export default function BannerTitles() {
  const classes = useStyles();

  const {register, errors, setValue} = useFormContext();

  const colorConfig = useStoreColorSettings();

  let textColorOptions = [
    {
      hex: '#FFFFFF',
      name: 'Blanco',
    },
    {
      hex: '#3A3A49',
      name: 'Negro',
    },
  ];

  return (
    <div className={classes.root}>
      <CustomTextField
        label=""
        name={MAIN_BANNER_FIELDS.TITLE}
        placeholder="Título del banner (Max. 40 caracteres incluyendo espacios)"
        inputRef={register({
          maxLength: {
            value: 40,
            message: 'Máximo 40 caracteres',
          },
        })}
        error={errors[MAIN_BANNER_FIELDS.TITLE]}
        helperText={
          errors[MAIN_BANNER_FIELDS.TITLE] &&
          errors[MAIN_BANNER_FIELDS.TITLE].message
        }
      />
      <CustomTextField
        label=""
        placeholder="Subtitulo de banner (Max. 25 caracteres incluyendo espacios)"
        name={MAIN_BANNER_FIELDS.SUBTITLE}
        inputRef={register({
          maxLength: {
            value: 25,
            message: 'Máximo 25 caracteres',
          },
        })}
        error={errors[MAIN_BANNER_FIELDS.SUBTITLE]}
        helperText={
          errors[MAIN_BANNER_FIELDS.SUBTITLE] &&
          errors[MAIN_BANNER_FIELDS.SUBTITLE].message
        }
      />
      <TextAndBackgroundColorSelector
        arrayTextColors={textColorOptions}
        onChange={(textColor, bgColor) => {
          setValue(MAIN_BANNER_FIELDS.TEXT_COLOR, textColor);
          setValue(MAIN_BANNER_FIELDS.BACKGROUND_COLOR, bgColor);
        }}
        defaultTextColor="#FFFFFF"
        defaultBackgroundColor={
          colorConfig && colorConfig.primaryBackgroundColor
        }
      />
    </div>
  );
}
